import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { HammerGestureConfig } from '@angular/platform-browser';
import 'hammerjs';

import { FormsModule } from '@angular/forms';
import { SwitchComponent } from './switch.component';

export class MyHammerConfig extends HammerGestureConfig {
  overrides = {
    pan: {threshold: 20} // override default settings
  };
}

@NgModule({
  imports: [
    CommonModule,
    FormsModule
  ],
  exports: [
    SwitchComponent,
  ],
  declarations: [SwitchComponent]
})
export class SwitchModule { }
